import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { CLUB_HOME_ROUTER } from "@icoach/router/routerPath";
import { Typography, Box } from "@curves/ui-base";
import { localUser } from "@util/utils";
import { getVersionData } from "@redux/version/selector";
import LogoSignDrop from "@images/login_1.svg";
import LogoSignPoint from "@images/login_2.svg";
import NavLogo from "@images/nav_logo.svg";
import { isEmpty } from "@util/utils";
import useMenusControlled from "@util/hook/useMenusControlled";
import NotificationBellBox from "@icoach/navigation/NotificationBellBox";
import PosBox from "@icoach/navigation/PosBox";
import StockBox from "@icoach/navigation/StockBox";
import routerFrontKey from "@icoach/constants/routerFrontKey";

const NavTop = props => {
	const { onCloseMenu } = props;
	const user = localUser.get();
	const employee = localUser.get("employee");
	const club = localUser.get("user-club");
	const reduxVersion = useSelector(getVersionData);
	let { env: ENV = "" } = reduxVersion;
	if (!["UAT", "DEV"].includes(String(ENV).toUpperCase())) {
		ENV = "";
	}

	const subName = !isEmpty(employee) ? employee.displayName : user.userName.indexOf("_admin") > 0 ? "管理者" : user.userName.indexOf("_owner") > 0 ? "加盟主" : user.userName;
	const mainName = !isEmpty(club) ? club.text : user.displayName.replace(subName, "");

	const navAdditionalButtons = useMenusControlled([
		{
			key: "stock",
			label: "庫存管理",
			className: "stock-icon",
			frontKey: routerFrontKey.INVENTORY,
			component: <StockBox />,
		},
		{
			key: "pos",
			label: "POS結帳",
			className: "pos-icon",
			frontKey: routerFrontKey.C12X01,
			component: <PosBox />,
		},
	]);

	const renderedButtons = useMemo(
		() => {
			return navAdditionalButtons.map(({ key, className, component }) => (
				<Box key={key} className={className}>
					{component}
				</Box>
			));
		},
		// eslint-disable-next-line
		[navAdditionalButtons],
	);

	return (
		<Box className="nav-top">
			<Box component="img" src={LogoSignDrop} className="logo-drop" alt="Curves_Design"></Box>
			<Box component="img" src={LogoSignPoint} className="logo-point" alt="Curves_Design"></Box>
			<Box className="logo-container">
				<Box className="logo-top-section">
					<Link to={CLUB_HOME_ROUTER.ARRIVE} onClick={onCloseMenu} className="logo-link">
						<img src={NavLogo} className="logo-nav" alt="Curves" />
						<Box className="logo-text-container">
							{ENV && (
								<Box component="span" className="env-store">
									{String(ENV).toUpperCase()}
								</Box>
							)}
							<Typography className="logo-store-text">{mainName}</Typography>
							<Typography className="logo-employee-text">{subName}</Typography>
						</Box>
					</Link>
				</Box>
			</Box>
			<Box className="icon-bottom-section">
				{renderedButtons}
				<Box className="notify-bell">
					<NotificationBellBox />
				</Box>
			</Box>
		</Box>
	);
};

export default NavTop;
